import Avatar from "@material-ui/core/Avatar";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

const useStyles = makeStyles((theme) => ({
  avatar: {
    margin: theme.spacing(2),
    backgroundColor: theme.palette.secondary.main,
    height: 60,
    width: 60,
  },
  infos: {
    backgroundColor: theme.palette.background.paper,
    padding: 0
  },
  avatarContainer: {
    display: "flex",
    justifyContent: "center"
  },
  h1: {
    textAlign: "center"
  }
}));

export default function About({currentUser = {}}) {
  const classes = useStyles();
  return (
    <div>
      <List
        component="nav"
        aria-label="main mailbox folders"
        className={classes.infos}
      >
        <ListItem>
          <ListItemIcon>
            <Avatar className={classes.avatar}>
              {currentUser.fullName?.substring(0, 1)}
            </Avatar>
          </ListItemIcon>
          <ListItemText primary={currentUser.fullName} secondary={currentUser.email} />
        </ListItem>
      </List>
    </div>
  );
}
